export const getCategoryHref = (slug: string) =>
  slug === 'games' ? '/games' : `/apps/category/${slug}`;
